<template>
    <div id="AppCommodity" style="padding-top: 100px;">
        <div class="text-2xl italic text-center">产品展示</div>
        <div class="imgList">
            <div v-for="item in imgList" :key="item" class="children">
                <a-popover title="商品详情">
                    <template slot="content">
                        <img :src="item.content" alt="">
                    </template>
                    <img :src="item.imgUrl" alt="">
                </a-popover>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
      return {
        imgList: [
            {   
                key: 1,
                imgUrl: require('@/assets/shop/shop1.jpg'),
                content: require('@/assets/shop/shop1de.png'),
                placement: 'top'

            },
            // {   
            //     key: 2,
            //     imgUrl: require('@/assets/shop/shop2.png'),
            //     content: require('@/assets/shop/shop2.png'),
            //     placement: ''

            // },
            // {   
            //     key: 3,
            //     imgUrl: require('@/assets/shop/shop3.png'),
            //     content: require('@/assets/shop/shop3.png'),
            //     placement: ''

            // },
            {   
                key: 4,
                imgUrl: require('@/assets/shop/shop4.png'),
                content: require('@/assets/shop/shop4de.png'),
                placement: 'top'

            },
            // {   
            //     key: 5,
            //     imgUrl: require('@/assets/shop/shop5.png'),
            //     content: require('@/assets/shop/shop5.png'),
            //     placement: ''

            // },
            {   
                key: 6,
                imgUrl: require('@/assets/shop/shop6.png'),
                content: require('@/assets/shop/shop6de.png'),
                placement: 'top'

            },
            {   
                key: 7,
                imgUrl: require('@/assets/shop/shop7.png'),
                content: require('@/assets/shop/shop7de.png'),
                placement: 'top'

            },
            // {   
            //     key: 8,
            //     imgUrl: require('@/assets/shop/shop8.png'),
            //     content: require('@/assets/shop/shop8.png'),
            //     placement: ''

            // }
        ]
      }
    }
}
</script>

<style scoped>
.imgList {
    max-width: 1300px;
    margin: 40px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 20px;
    border: 1px solid #eee;
    padding: 40px;
    background-color: #f8fafc;
    box-shadow: 0 2PX 8PX 0 #d8dde6;
}
.imgList .children {
    width: 280px;
    height: 280px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
}
</style>
